<template>
  <div class="row">
    <div class="col">

      <!-- form new item -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <!-- guest name -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Nome do Hóspede</label>
                    <input class="form-control" :disabled="true" type="text" placeholder="Nome do Hóspede" v-model="guest_name" required>
                  </div>
                </div>

                <!-- record_number -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Número da Ficha</label>
                    <input class="form-control" :disabled="true" type="text" placeholder="Número da Ficha" v-model="record_number" required>
                  </div>
                </div>

                <!-- total -->
                <div class="col-md-2 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Total</label>
                    <input class="form-control" :disabled="true" type="number" v-model="total" required>
                  </div>
                </div>

                <!-- company id -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Empresa</label>
                    <v-select :options="filterCompanies" :disabled="true" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="company_id" @input="validateCompany()"></v-select>
                  </div>
                </div>

                <!-- contract -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Contrato</label>
                    <v-select :options="filterContracts" :disabled="true" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="contract_id"></v-select>
                  </div>
                </div>

                <!-- work_place_id -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label">Local de Trabalho</label>
                    <v-select :options="filterWorkplaces" :disabled="true" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="workplace_id" @input="validateWorkplace()"></v-select>
                  </div>
                </div>

                <!-- sublocal -->
                <div class="col-md-6 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-sublocal">Sublocal</label>
                    <v-select :options="filterSublocal" :disabled="true" label="corporate_name" :reduce="corporate_name => corporate_name.id" v-model="sublocal_id" @input="loadSectors()"></v-select>
                  </div>
                </div>

                <!-- sector_id -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-sector_id">Setor</label>
                    <v-select :options="filterSectors" :disabled="true" label="name" :reduce="name => name.id" v-model="sector_id" @input="validateSector()"></v-select>
                  </div>
                </div>
                
                <!-- subsector_id -->
                <div class="col-md-5 mt-2">
                  <div class="form-group">
                    <label class="form-control-label" for="input-subsector_id">Subsetor</label>
                    <v-select :options="filterSubsectors" :disabled="true" :reduce="name => name.id" label="name" v-model="subsector_id"></v-select>
                  </div>
                </div>

                <div class="col-md-2 text-end" style="text-align:right;" v-if="status != 1">
                  <button href="#" class="btn btn-success btn-block" :disabled="items.length == 0 ? true : false" style="height:40px;padding-top:7px;margin-top:35px;" @click="updateData()">ATUALIZAR</button>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="items.length > 0">
        <div class="col-md-12">

          <div class="card" v-for="(item, index) in items" :key="index" style="padding: 20px;">
            <div class="row">
              <div class="col-md-10">
                <h5 style="font-size:14px;"><b>Observações Entrada:</b><br/>{{ item.observations_before }}</h5>
              </div>
              <div class="col-md-2 text-end" style="text-align: right;" v-if="item.observations_after == null">
                <button class="btn btn-sm btn-outline-success" @click="showItem(item)" title="Atualizar"><i class="fas fa-check"></i></button>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <div class="col-md-1 mb-3 position-relative" v-for="(file, indexFile) in getImageFiles(item, 1)" :key="indexFile">
                    <img :src="'https://mvtecnologiaegestao.com/storage/' + 'governance/' + file.path" class="img-thumbnail" style="cursor: pointer;" @click="openImageModal('https://mvtecnologiaegestao.com/storage/' + 'governance/' + file.path)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2" v-if="item.status == 'updated'">
              <div class="col-md-10">
                <h5 style="font-size:14px;"><b>Observações Saída:</b><br/>{{ item.observations_after }}</h5>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <div class="col-md-1 mb-3 position-relative" v-for="(file, indexFile) in item.files_after" :key="indexFile">
                    <img :src="file.url" class="img-thumbnail" style="cursor: pointer;" @click="openImageModal(file.url)" />
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-else-if="item.observations_after !== null">
              <div class="col-md-10">
                <h5 style="font-size:14px;"><b>Observações Saída:</b><br/>{{ item.observations_after }}</h5>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                    <div class="col-md-1 mb-3 position-relative" v-for="(file, indexFile) in getImageFiles(item, 2)" :key="indexFile">
                    	<img :src="'https://mvtecnologiaegestao.com/storage/' + 'governance/' + file.path" class="img-thumbnail" style="cursor: pointer;" @click="openImageModal('https://mvtecnologiaegestao.com/storage/' + 'governance/' + file.path)" />
                    </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div v-else class="text-center p-3 text-muted">
        <h5>Nenhum item adicionado!</h5>
      </div>
    </div>

    <!-- modal preview -->
    <div class="modal fade" id="imageModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content bg-transparent border-0">
          <div class="modal-body text-center p-0 position-relative">
            <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Fechar"></button>
            <img :src="selectedImage" v-if="selectedImage" class="img-fluid rounded shadow" />
          </div>
        </div>
      </div>
    </div>

    <!-- modal -->
    <div class="modal fade" id="modalUpdate" tabindex="-1" aria-labelledby="modalUpdateLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalUpdateLabel">Atualizar Item</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form v-on:submit.prevent="updateItem">

              <div class="row">

                <!-- observations -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-control-label" for="input-observations">Observações</label>
                    <textarea type="text" id="input-observations" class="form-control" placeholder="Observações" v-model="observations" rows="4" required="false"></textarea>
                  </div>
                </div>

                <!-- file -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="form-control-label" for="input-file">Fotos</label>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" multiple id="file" name="file" ref="file" lang="pt" v-on:change="handleFileUpload">
                      <label class="custom-file-label" for="file">{{fileName}}</label>
                    </div>
                  </div>
                </div>

                <!-- list files -->
                <div class="row p-3" v-if="files.length > 0">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 mb-3 position-relative" v-for="(file, index) in files" :key="index">
                        <button type="button"
                                class="btn btn-sm btn-danger text-white position-absolute"
                                style="top: -10px; right: -10px; border-radius: 50%; width: 24px; height: 24px; z-index: 10; padding: 0;"
                                @click.stop="removeImage(index)">
                          ×
                        </button>

                        <img :src="file.url"
                            class="img-thumbnail"
                            style="cursor: pointer;"
                            @click="openImageModal(file.url)" />

                        <small class="d-block text-truncate mt-1">{{ file.name }}</small>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="text-right">
                <button type="submit" class="btn btn-success">SALVAR</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <vue-loading color="#212121" :active.sync="loading" :can-cancel="false" :is-full-page="fullPage"></vue-loading>
  </div>
</template>

<script>
import configData from "../../config.js";
import ApiService from '../../apiservice.js';
export default {
  mixins: [ApiService, configData],
  props: ['_governance','_items'],
  data() {
    return {
      guest_name: this.getData('guest_name'),
      record_number: this.getData('record_number'),
      total: this.getData('total'),
      observations: null,
      company_id: this.getData('company_id'),
      contract_id: this.getData('contract_id'),
      workplace_id: this.getData('workplace_id'),
      sublocal_id: this.getData('sublocal_id'),
      sector_id: this.getData('sector_id'),
      subsector_id: this.getData('subsector_id'),
      status: this.getData('status'),
      selectedItem: null,
      files: [],
      fileName: 'Selecione as fotos',
      items: JSON.parse(this._items) || [],
      itemsUpdated: [],
      filterCompanies: [],
      filterContracts: [],
      filterWorkplaces: [],
      filterSublocal: [],
      filterSectors: [],
      filterSubsectors: [],
      loading: false,
      fullPage: true,
      selectedImage: null
    }
  },
  mounted() {
    this.loadCompanies();
  },
  methods: {
    getData(key) {
      return JSON.parse(this._governance)[key];
    },
    handleFileUpload() {
      const selectedFiles = this.$refs.file.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          this.files.push({
            name: file.name,
            url: e.target.result
          });
        };
        reader.readAsDataURL(file);
      }
      this.fileName = `${selectedFiles.length} arquivo(s) selecionado(s)`;
    },
    deleteData(index) {
      this.items.splice(index, 1);
    },
    showItem(item){
      this.selectedItem = item;
      this.files = [];
      this.observations = null;
      $('#modalUpdate').modal('show');
    },
    updateData() {
      let _this = this;
      _this.loading = true;

      let formData = new FormData();
      formData.append("items", JSON.stringify(_this.itemsUpdated));
      formData.append("_method", "PATCH");

      axios.post("/portal/governance/"+_this.getData('hash'), formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {

        _this.loading = false;

        //call function in ApiService to validate success
        _this._api_validateSuccess(res,true);

      }).catch((err) => {

        _this.loading = false;

        if (err.response.data.errors){
          //set errors
          _this.errors = err.response.data.errors;
        }

        //call function in ApiService to validate error
        _this._api_validateError(err);

      });

    },
    openImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.$nextTick(() => {
        const modal = new bootstrap.Modal(document.getElementById('imageModal'));
        modal.show();
      });
    },
    removeImage(index) {
      this.files.splice(index, 1);
      this.fileName = `${this.files.length} arquivo(s) selecionado(s)`;
    },
    storeItem() {
      if (this.observations && this.files.length > 0) {
        this.items.push({
          observations: this.observations,
          files: this.files
        });
        this.observations = null;
        this.files = [];
        this.fileName = 'Selecione as fotos';
      } else {
        
      }
    },
    loadCompanies() {
      let _this = this;
      axios.get("/admin/companies").then((res) => {
        res.data.sort(function(a, b){
          return a.corporate_name - b.corporate_name;
        });
        _this.filterCompanies = _this.filterCompanies.concat(res.data);
        _this.validateCompany();
        _this.validateWorkplace();
        _this.loadSectors();
        _this.validateSector();
      }).catch((err) => {
      });
    },
    loadContracts() {
      let _this = this;
      _this.loading = true;
      _this.filterContracts = [];
      axios.get("/admin/companycontracts/"+_this.company_id+"/search").then((res) => {
        res.data.map((rowContract) => {
          _this.filterContracts.push({
            id: rowContract.contract_id,
            corporate_name: rowContract.contracts.corporate_name
          });
        });
        _this.filterContracts.sort(function(a, b){
          return a.corporate_name - b.corporate_name;
        });
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
      });
    },
    loadSectors() {
      let _this = this;
      _this.loading = true;

      _this.filterSectors = [];

      axios.get("/admin/sectors/"+_this.sublocal_id+"/search").then((res) => {
        res.data.sort(function(a, b){
          return a.name - b.name;
        });
        _this.filterSectors = _this.filterSectors.concat(res.data);
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
    });

    },
    validateCompany(){
      let _this = this;
      _this.loading = true;

      _this.filterWorkplaces = [];
      axios.get("/admin/companyworkplaces/"+_this.company_id+'/search').then((res) => {
        res.data.map((rowReturn) => {
          _this.filterWorkplaces = _this.filterWorkplaces.concat(rowReturn.work_places);
        });
        _this.filterWorkplaces.sort(function(a, b){
          return a.corporate_name - b.corporate_name;
        });
        _this.loadContracts();
      }).catch((err) => {
      });
      this.loading = false;
    },
    validateSector(){
      let _this = this;
      _this.filterSubsectors = [];
      _this.loading = true;
      axios.get("/admin/subsectors/"+_this.sublocal_id+"/search").then((res) => {
        res.data.map((rowSubsector) => {
          if(rowSubsector.sector_id == _this.sector_id){
            _this.filterSubsectors.push(rowSubsector);
          }
        });
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
      });
    },
    validateWorkplace(){
      let _this = this;

      _this.filterSublocal = [];
      axios.get("/admin/workplacesublocal/"+_this.workplace_id+"/search").then((res) => {
        res.data.map((rowSublocal) => {
          _this.filterSublocal.push({
            corporate_name: rowSublocal.sublocal.corporate_name,
            id: rowSublocal.sublocal_id
          });
        });
        _this.loading = false;
      }).catch((err) => {
        _this.loading = false;
      });

    },
    updateItem() {
      this.itemsUpdated.push({
        id: this.selectedItem.id,
        observations: this.observations,
        files: this.files
      });
      this.items.map((rowItem) => {
        if(rowItem.id == this.selectedItem.id){
          rowItem.observations_after = this.observations;
          rowItem.files_after = this.files;
          rowItem.status = 'updated';
        }
      })
      $('#modalUpdate').modal('hide');
      this.selectedItem = null;
      this.observations = null;
      this.files = [];
      this.fileName = 'Selecione as fotos';
    },
    getImageFiles(item, type) {
      if (!item.files) return [];
      return item.files.filter(file => {
        if (typeof file.type === 'string') {
          return file.type.startsWith('image/');
        }
        return file.type === type;
      });
    },
  }
}
</script>
